export const transformArrayToString = (arr?: unknown) =>
  Array.isArray(arr) && arr?.map((num) => num + 'px').join(' ')
